export default function shouldEnforceAgeAssurance({ userId }: { userId: number }) {
  // A temporary condition for the beginning of the rollout to only enforce
  // age assurance for 1/5th of the users for whom it should otherwise be
  // enforced while we address any issues with the user experience or system.
  return [0, 1].includes(userId % 10)
}
